// The hours-category palette lives in `theme/tokens.ts` as `HOURS_SUMMARY` — import it from there.
// It was seven feature-local hex constants here, which meant the colors ignored the user's theme.

export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

const EMPLOYMENT_TYPE_KEYS: Record<string, string> = {
	fullTime: "employment.type.full.time",
	partTime: "employment.type.part.time",
	perDiem: "employment.type.agency",
	travel: "employment.type.travel",
	floatPool: "employment.type.float.pool",
	PRN: "employment.type.prn",
};

export function getEmploymentTypeLabel(type: string, t: (key: string) => string): string {
	const key = EMPLOYMENT_TYPE_KEYS[type];
	return key ? t(key) : t("employment.type.full.time");
}
